module.exports = __webpack_public_path__ + "assets/img/ppb.76b4d21a.png";